import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, of } from 'rxjs';
import { ApplicationsService } from '../shared/services/applications/applications.service';
import { ApplicationsStore } from '../shared/stores/applications/applications.store';
import { ClientStore } from '../shared/stores/client/client.store';

/**
 * Preloads applications data for the applications routes.
 * Ensures data is available whether navigating directly or from dashboard.
 * Follows the same pattern as openBankingResolver.
 * @returns Observable<boolean> indicating success
 */
export const applicationsResolver: ResolveFn<boolean> = () => {
  const clientStore = inject(ClientStore);
  const applicationsService = inject(ApplicationsService);
  const applicationsStore = inject(ApplicationsStore);

  const hasApplications = !!applicationsStore.applications?.()?.length;

  const client = clientStore.client?.();

  if (!client?.clientId) {
    throw new Error('Client ID is required for applications data');
  }

  // If already loaded, return immediately
  if (hasApplications) {
    return of(true);
  }

  return applicationsService.get(client.clientId).pipe(map(() => true));
};
